const initialState = {
    projects: [],
    error: null,
    isLoading: false
  };


const ProjectApiReducer = (state = initialState, action) =>{
    switch (action.type) {
        case "LOADING":
          return {
            ...state,
            isLoading: action.payload
          };
    
        case "GET_PROJECTS_SUCCESS":
          return {
            ...state,
            projects: action.payload,
            error: null
          };
        case "GET_PROJECTS_FAILURE":
          return {
            ...state,
            error: action.payload.error
          };
    
        case "ADD_PROJECTS_SUCCESS":
          return {
            ...state,
            error: null
          };
        case "ADD_PROJECTS_FAILURE":
          return {
            ...state,
            error: action.payload.error
          };

        case "UPDATE_PROJECT_SUCCESS":
            return{
              ...state,
              error: action.payload.error
            };
      
        case "UPDATE_PROJECT_FAILURE":
            return{
              ...state,
             
              error: action.payload.error
            };
          
        case "DELETE_PROJECT_SUCCESS":
            return{
              ...state,
              projects: state.projects.filter((Project) => Project.id !== action.payload),
              error: null
            };
      
        case "DELETE_PROJECT_FAILURE":
            return{
              ...state,
              error: action.payload.error
            }
        
        default:
            return state;
  }


};

export default ProjectApiReducer;